import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HomeEnPage = lazy(() => import('../pages/home-en/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/en',
    element: <HomeEnPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
